import {Color} from "@k/js/colorObject";
import {
    Entwurf,
    EntwurfConstructorArguments,
    EntwurfLoadingStati,
} from "@k/js/entwurfsObjekt";

import {ChromoLogo, Logo, StockLogo, TextObject} from "@k/js/selectableObjects";
import {PatternInEntwurf} from "@k/js/pattern/patternEntwurfsobjektInteractor";
import {EinzelExemplar} from "@k/global/einzelexemplare/einzelExemplarObject";
import {Z_OrderTable} from "@k/js/zOrderTable";
import {ENTWURFDATA} from "@k/js/EntwurfStateWrapper"
import {ColorCodeFarbKombiBeziehung} from "@k/js/databaseInterfaceClasses";

export default {
    state: () => ({
        id : "",
        design : "",
        model : "",
        productCategory : "",
        colorObjects : [] as Color[],
        logoObjects : [] as (Logo|StockLogo|ChromoLogo)[],
        textObjects : [] as TextObject[],
        patterns : [] as PatternInEntwurf[],
        exemplarListe : [] as EinzelExemplar[],
        zOrderTable : new Z_OrderTable(),
        loadStatus : new EntwurfLoadingStati(),
        inBasket : false,
        designanfrage : false,
        changedSinceSave : false,
        owayoLogosOnTop : false,
        uploadedByOwayo : false,
        basedOnDeprecatedProduct : false,
        farbvariante : "",
        name : "",
        wasOrdered : false,
        fbPostID : "",
        rdyDesignID : "",
        herstellerlogosEntfernt	: false,
        loadstatus:{
            logoObjects: false, textObjects: false, exemplareList: false,
            colorObjects: false
        },
    }),
    getters: {

        getTextObjects: (state: ENTWURFDATA) => state.textObjects,
        getLogoObjects: (state: ENTWURFDATA) => state.logoObjects,
        getTextObjectById: (state: ENTWURFDATA) => id => (state.textObjects.find(to => to.id === id)) || null,
        getLogoObjectById: (state: ENTWURFDATA) => id => (state.logoObjects.find(lo => lo.id === id)) || null,
        getCurrentDesignname: (state: ENTWURFDATA) => state.design || "",
        getEntwurfColorObjects: (state: ENTWURFDATA): Color[] => state.colorObjects || [],
        getChangedSinceSave: (state: ENTWURFDATA) => state.changedSinceSave || false,
        getColorCodeFromColorCodeNr: () => (nr) => Entwurf.getColorCodeFromColorCodeNr(nr),
        getColorCodeNr: (state:ENTWURFDATA) => (colorcodeString) => {
            const o = state.colorObjects.find(c => c.colorCode === colorcodeString) || null;
            if (o !== null) {
                return o.colorCodeNr;
            }
            return -1;
        },
        getColorObjectByColorCode: () => (changedColorCode) => Entwurf.getColorObjectByColorCode(changedColorCode),
        getColorObjects: (state: ENTWURFDATA) => state.colorObjects,
        getDesignAnfrage: (state: ENTWURFDATA) => state.designanfrage,
        getbasedOnDeprecatedProduct:(state:ENTWURFDATA)=>state.basedOnDeprecatedProduct,
        getUploadedByOwayo:(state:ENTWURFDATA)=>state.uploadedByOwayo,
        getExemplarListe: (state: ENTWURFDATA): EinzelExemplar[] => state.exemplarListe,
        getFBPostID: (state: ENTWURFDATA): string => state.fbPostID,
        getRdyDesignID: (state: ENTWURFDATA): string => state.rdyDesignID,
        getHerstellerlogosEntfernt: (state: ENTWURFDATA): boolean => state.herstellerlogosEntfernt,
        getFarbvariante: (state: ENTWURFDATA): string => state.farbvariante,
        getEntwurfsID: (state: ENTWURFDATA): string => state.id,
        getInBasket: (state: ENTWURFDATA): boolean => state.inBasket,
        getModel: (state: ENTWURFDATA): string => state.model,
        getEntwurfname: (state: ENTWURFDATA): string => state.name,
        getOwayoLogosOnTop: (state: ENTWURFDATA): boolean => state.owayoLogosOnTop,
        getPattern: (state: ENTWURFDATA) => colorCodeOnEntwurf => state.patterns.find(p => p.forColorCode === colorCodeOnEntwurf) || null,
        getPatterns: (state: ENTWURFDATA) => state.patterns,
        getProductCategory: (state: ENTWURFDATA) => state.productCategory,
        getSelOb: () => (id) => Entwurf.getSelOb(id),
        getZOrderTable: (state: ENTWURFDATA): Z_OrderTable => state.zOrderTable,
        getZIndex: (state: ENTWURFDATA) => id => state.zOrderTable.getZIndex(id),
        isOwayoLogosOnTop: (state: ENTWURFDATA): boolean => state.owayoLogosOnTop,
        needsSaving: (): boolean => Entwurf.needsSaving(),
        wasOrdered: (state: ENTWURFDATA): boolean => state.wasOrdered,
        getEntwurfData:state=>state
    },
    mutations: {
        RESET_ENTWURF: (state: ENTWURFDATA, args:EntwurfConstructorArguments) => {
                state.id =  args.id;
                state.design =  args.design;
                state.model =  args.model;
                state.productCategory =  args.productCategory;
                state.colorObjects =  [] as Color[];
                state.logoObjects =  [] as (Logo|StockLogo|ChromoLogo)[];
                state.textObjects =  [] as TextObject[];
                state.patterns =  [] as PatternInEntwurf[];
                state.exemplarListe =  [] as EinzelExemplar[];
                state.zOrderTable =  new Z_OrderTable();
                state.loadStatus =  new EntwurfLoadingStati();
                state.inBasket =  parseInt(args.isInWarenkorb) === 1;
                state.designanfrage =  false;
                state.changedSinceSave =  false;
                state.owayoLogosOnTop =  true;
                state.uploadedByOwayo =  args.uploadedByOwayo || false;
                state.basedOnDeprecatedProduct =  args.basedOnDeprecatedProduct || false;
                state.farbvariante =  "";
                state.name =  args.name || "";
                state.wasOrdered =  args.wasOrdered || false;
                state.fbPostID =  "";
                state.loadStatus = {
                    logoObjects: false, textObjects: false, exemplareList: false,
                    colorObjects: false
                }
                if(args.startDirty) {
                    state.changedSinceSave = true;
                }
        },
        ADD_LOGO: (state: ENTWURFDATA, logo: StockLogo | ChromoLogo | Logo) => {
            state.logoObjects.push(logo);
        },
        ADD_PATTERN: (state: ENTWURFDATA, pattern: PatternInEntwurf) => {
            state.patterns.push(pattern);
        },
        ADD_TEXTOBJECT: (state: ENTWURFDATA, text: TextObject) => {
            state.textObjects.push(text);
        },
        ADD_EXEMPLAR : (state:ENTWURFDATA, exemplar:EinzelExemplar)=>{
            state.exemplarListe.push(exemplar);
        },
        ADD_COLOR : (state:ENTWURFDATA, color:Color)=> {
            state.colorObjects.push(color);
        },

        DELETE_PATTERN_FOR_COLORCODE(state: ENTWURFDATA, colorCode: string): void {
            state.patterns = state.patterns.filter(e => e.forColorCode !== colorCode);
        },
        DELETE_ALL_PATTERNS(state:ENTWURFDATA) {
            state.patterns = [];
        },

        DELETE_SELOB_BY_ID(state:ENTWURFDATA, cloneId: string): void {
            Entwurf.deleteSelObById(cloneId);
        },

        INSERT_ZINDEX_ENTRY(state: ENTWURFDATA, {id, cloneIds, floating}) {
            state.zOrderTable.insertEntry(id, cloneIds, floating);
        },

        LOAD_EINZELEXEMPLARE(state: ENTWURFDATA, einzelexemplare) {
            Entwurf.loadEinzelexemplare(einzelexemplare);
        },
        LOAD_LOGOOBJECTS(state: ENTWURFDATA, logos) {
            Entwurf.loadLogoObjects(logos);
        },

        LOAD_TEXTOBJECTS(state: ENTWURFDATA, textObjects) {
            Entwurf.loadTextObjects(textObjects);
        },

        SET_CHANGED_SINCE_SAVE_FLAG(state: ENTWURFDATA, changedSinceSave: boolean) {
            state.changedSinceSave = changedSinceSave;
        },
        SET_CLONE_FLAGS() {
            Entwurf.setCloneFlags();
        },
        LOAD_COLOR_VALUES(state:ENTWURFDATA, colorsFromDB) {
            Entwurf.loadColorValues(colorsFromDB);
        },
        SET_COLOROBJECTS(state: ENTWURFDATA, colorObjects: Color[]) {
            state.colorObjects = colorObjects;
        },
        SET_DEPENDENCY_AND_DEPENDENT_COLOR_VALUES(state:ENTWURFDATA, farbBeziehungenZwischenColorCodes:ColorCodeFarbKombiBeziehung[]) {
            Entwurf.setDependencyAndDependentColorValues(farbBeziehungenZwischenColorCodes);
        },
        SET_DESIGNANFRAGE_FLAG(state: ENTWURFDATA, isDesignanfrage: boolean) {
            state.designanfrage = isDesignanfrage;
        },
        SET_ENTWURF_DESIGNNAME(state: ENTWURFDATA, designname: string) {
            state.design = designname;
        },
        SET_EXEMPLARLISTE(state: ENTWURFDATA, einzelexemplare: EinzelExemplar[]) {
            state.exemplarListe = einzelexemplare
        },
        SET_FBPOST_ID(state: ENTWURFDATA, id: string) {
            state.fbPostID = id;
        },
        SET_RDYDESIGN_ID(state: ENTWURFDATA, id: string){
            state.rdyDesignID = id;
        },
        SET_HERSTELLERLOGO_AS_DELETED(state: ENTWURFDATA, deleted: boolean){
            state.herstellerlogosEntfernt = deleted;
        },
        SET_FARBVARIANTE(state: ENTWURFDATA, variantenname: string) {
            state.farbvariante = variantenname;
        },
        SET_ENTWURF_ID(state: ENTWURFDATA, id: string) {
            state.id = id;
        },
        SET_ENTWURF_changedSinceSave(state: ENTWURFDATA) {
            state.changedSinceSave = true;
        },
        SET_INBASKET_FLAG(state: ENTWURFDATA, isInBasket: boolean) {
            state.inBasket = isInBasket;
        },
        SET_ENTWURF_NAME(state: ENTWURFDATA, name: string) {
            state.name = name;
        },
        SET_OWAYO_LOGOS_ON_TOP_FLAG(state: ENTWURFDATA, areOnTop: boolean) {
            state.owayoLogosOnTop = areOnTop;
        },
        UPDATE_COLORCODES(state: ENTWURFDATA, {
            colorCodes,
            ColorCodeFarbVorbelegungen,
            ColorCodeAbhaengigkeiten,
            farbBeziehungenZwischenColorCodes
        }) {
            Entwurf.updateColorCodes(colorCodes, ColorCodeFarbVorbelegungen, ColorCodeAbhaengigkeiten, farbBeziehungenZwischenColorCodes);
        },
        REPLACE_COLOROBJECT(state:ENTWURFDATA, {index,  newColor}) {
            state.colorObjects[index] = newColor;
        },
        SET_BASED_ON_DEPRECATED_PRODUCT(state:ENTWURFDATA, b:boolean) {
            state.basedOnDeprecatedProduct = b;
        },


        SET_TEXTS(state:ENTWURFDATA, texts:TextObject[]) {
            state.textObjects = texts;
        },
        SET_LOGOS(state:ENTWURFDATA, logos:(Logo|StockLogo|ChromoLogo)[]) {
            state.logoObjects = logos;
        },
        SET_MODEL(state:ENTWURFDATA, m:string) {
            state.model =m;
        },
        SET_PATTERNS(state:ENTWURFDATA, p:PatternInEntwurf[]) {
            state.patterns = p;
        },
        SET_ENTWURF_PRODUCTCATEGORY(state:ENTWURFDATA, cat:string) {
            state.productCategory = cat;
        },
        SET_UPLOADED_BY_OWAYO(state:ENTWURFDATA, b:boolean) {
            state.uploadedByOwayo = b;
        },
        SET_ENTWURF_WAS_ORDERED(state:ENTWURFDATA, b:boolean) {
            state.wasOrdered = b;
        },
        SET_ZORDER_TABLE(state:ENTWURFDATA, z:Z_OrderTable) {
            state.zOrderTable = z;
        },
        RESET_LOADSTATUS(state:ENTWURFDATA) {
            state.loadStatus = {
                logoObjects: false, textObjects: false,  exemplareList: false,
                colorObjects: false
            }
        },
        SET_LOADSTATUSTOTRUE(state:ENTWURFDATA, whichone: "TEXT" | "LOGO" | "COLOR" | "EXEMPLARLISTE") {
            switch(whichone) {
                case "COLOR":
                    state.loadStatus.colorObjects = true;
                    break;
                case "LOGO":
                    state.loadStatus.logoObjects = true;
                    break;
                case "TEXT":
                    state.loadStatus.textObjects = true
                    break;
                case "EXEMPLARLISTE":
                    state.loadStatus.exemplareList = true;
                    break
            }
        }
    },
    actions:{
        patternCreated(context, stockLogo:StockLogo) {
            const colorCode = context.getter.getColorCodeFromColorCodeNr(stockLogo.clampToColor);
            context.commit(
                "ADD_PATTERN",
                new PatternInEntwurf(
                    stockLogo.stockLogoID,
                    colorCode,
                    stockLogo.targetSizeCM || stockLogo.standardSizeCM,
                    stockLogo.colors
                )
            );
        }
    }
}

